import {first} from 'lodash';

import {nativeLaunchMetric, splashHiddenMetric} from './appLoadMetricCommon';
import {performance} from './performanceClient';

export function buildMobileAppLoadData() {
  const nativeAppFetchTiming = measureNativeAppFetch();
  if (!nativeAppFetchTiming) {
    return undefined;
  }

  return {
    // Convert performance time to UNIX timestamp.
    startTime: Date.now() - performance.timeOrigin + nativeAppFetchTiming.startTime,
    appFetchDuration: nativeAppFetchTiming.duration,
  };
}

/*
 * Helpers.
 */

function measureNativeAppFetch() {
  const splashHiddenPerfMetrics = performance.getEntriesByName(splashHiddenMetric);
  if (splashHiddenPerfMetrics.length === 0) {
    return undefined;
  }

  if (performance.getEntriesByType('react-native-mark').some((entry) => entry.name === 'nativeLaunchStart')) {
    performance.measure(nativeLaunchMetric, 'nativeLaunchStart', splashHiddenMetric);
    return first(performance.getEntriesByName(nativeLaunchMetric));
  }

  return undefined;
}
